import { StateCreator } from 'zustand'
import { DepartmentFilters, SharedState } from './types'
import { ContextState } from '../context'
import { ProductsState } from '../products'
import { FiltersState } from '../filters'
import { updateRoute } from '../../helpers'

export const createSharedSlice: StateCreator<
  SharedState &
    Partial<ContextState> &
    Partial<ProductsState> &
    Partial<FiltersState>
> = (set, get) => ({
  loading: false,
  departmentFilters: {} as DepartmentFilters,
  toggleLoading: (loading = true) => {
    set({
      loading,
    })
  },
  changeDepartment: async department => {
    const {
      pageContext: /* istanbul ignore next */ { router } = { router: null },
      searchContext,
      selectedFilters,
      selectedCategories,
      filters,
      departmentFilters,
      preAppliedFilters,
    } = get()

    const currentDepartment =
      searchContext?.departments[0].toString() || /* istanbul ignore next */ ''

    const updatedDepartmentFilters = {
      ...departmentFilters,
      [currentDepartment]: {
        selectedFilters,
        selectedCategories,
        filters,
      },
    }

    const persistedDepartmentFilters = updatedDepartmentFilters[department] || {
      selectedFilters: [],
      selectedCategories: [],
      filters: [],
    }

    set(() => {
      return {
        departmentFilters: updatedDepartmentFilters,
      }
    })

    updateRoute({
      router,
      selectedFilters: persistedDepartmentFilters.selectedFilters,
      department,
      preAppliedFilters: preAppliedFilters || /* istanbul ignore next */ [],
      mostRecentSearchTerm: searchContext?.searchTerm,
    })
  },
})
